import { axiosInstance, requestConfig } from 'network/apis';
import { URL_SYSTEM } from "utils/constants";

export const callEditShopClientPassword = async ( shopGuid, data) => {
    try {
        return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop/${shopGuid}/client-password-change`, data));
    } catch (error) {
        console.error('Failed to edit shop manager info:', error);
        return { data: null };  // 에러 발생 시 기본값 반환
    }
};

